import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, notFound, useNavigate } from "@tanstack/react-router"

import { IdentityDocumentDetail } from "@/features/individuals/components/identity-document-detail"
import { individualQueries } from "@/queries/individuals"
import { reviewQueries } from "@/queries/reviews"

/** One identity document, opened from the person's review to confirm it. */
export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/reviews/$reviewId/parts/$section/$documentId/"
)({
  loader: async ({ context, params }) => {
    const review = await context.queryClient.ensureQueryData(
      reviewQueries.detail(params.reviewId)
    )

    if (review.subject?.type !== "individual") {
      throw notFound()
    }

    await context.queryClient.ensureQueryData(
      individualQueries.identityDocuments(review.subject.id)
    )
  },
  component: ReviewIdentityDocumentPage,
})

function ReviewIdentityDocumentPage() {
  const { reviewId, section, documentId } = Route.useParams()
  const { data: review } = useSuspenseQuery(reviewQueries.detail(reviewId))
  const navigate = useNavigate()

  if (!review.subject) {
    return null
  }

  return (
    <IdentityDocumentDetail
      individualId={review.subject.id}
      documentId={documentId}
      onRemoved={() =>
        navigate({
          from: "/$organisation",
          to: "/$organisation/reviews/$reviewId/parts/$section",
          params: { reviewId, section },
        })
      }
    />
  )
}
